import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import { PostgrestSingleResponse } from '@supabase/supabase-js';
import {
  addCrmSalesTicket as addCrmSalesTicketService,
  fetchCrmSalesTickets,
  updateCrmSalesTicket as updateCrmSalesTicketService
} from './services';
import {
  CreateCrmSalesTicketPayload,
  CrmSalesFilterPayload,
  CrmSalesTicket,
  UpdateCrmSalesTicketPayload
} from './types';

export const fetchCrmSalesTicket = createAsyncThunk<
  PostgrestSingleResponse<CrmSalesTicket[]>,
  CrmSalesFilterPayload | undefined,
  { state: RootState }
>('crm-sales/fetchCrmSalesTicket', async (data) => {
  const response = await fetchCrmSalesTickets(data?.status, {
    search_customer: data?.search_customer,
    sort_by: data?.sort_by,
    start_date: data?.start_date,
    end_date: data?.end_date,
    limit: data?.limit,
    offset: data?.offset
  });

  if (response.error) {
    throw new Error('Failed API Call on fetchCrmSalesTicket');
  }

  return response;
});

export const addCrmSalesTicket = createAsyncThunk<
  PostgrestSingleResponse<null>,
  CreateCrmSalesTicketPayload,
  { state: RootState }
>('crm-sales/addCrmSalesTicket', async (data) => {
  const response = await addCrmSalesTicketService(data);

  if (response.error) {
    throw new Error('Failed API Call on addCrmSalesTicket');
  }

  return response;
});

export const updateCrmSalesTicket = createAsyncThunk<
  PostgrestSingleResponse<null>,
  UpdateCrmSalesTicketPayload,
  { state: RootState }
>('crm-sales/updateCrmSalesTicket', async (data) => {
  const response = await updateCrmSalesTicketService(data.id, data.data);

  if (response.error) {
    throw new Error('Failed API Call on updateCrmSalesTicket');
  }

  return response;
});
